import { $Q, $Qll } from "../utils/query-selector";

Shopify.queryParams = {};

/**
 * Update sort_by query parameter on select change
 */
export const defultSortBy = () => {
  $Q('.collection_custom-select')
  .addEventListener(
    'change',
    function({ target }) {

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const q = urlParams.get('q');
      const type = urlParams.get('type');
      Shopify.queryParams.sort_by = target.value;
      if (q !== null && type !== null){
        Shopify.queryParams.q = q;
        Shopify.queryParams.type = type;
      }
      const filterParams = $Qll(".collections--filter-urlparam")
      filterParams.map((element) => {
        const filter = urlParams.get(element.value);
        if (filter !== null){
          const param = {[element.value]:filter}
          Shopify.queryParams = Object.assign(param,Shopify.queryParams)
        }
      })
      location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
}
